export const styles = (theme) => ({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 440,
    overflowX: 'auto'
  },
  errorStyle: {
    color: 'red'
  },

  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white
  },
  addUser: {
    // marginBottom: '20px',
    minWidth: 120
  },

  display: {
    display: 'flex'
  },
  posClass: {
    cursor: 'pointer',
    color: '#005d83',
    '&:hover': {
      fontWeight: 'bold',
      color: '#005d83',
      textDecoration: 'underline',
      textDecorationColor: '#005d83'
    }
  },
  customDisplay: {
    position: 'relative'
  },
  customText: {
    position: 'absolute',
    top: '10%',
    left: '80%',
    width: '50%'
  },
  fontSize: {
    fontSize: '15px',
    fontWeight: '400'
  },

  appBar: {
    position: 'relative'
  },
  title: {
    flex: 1,
    textAlign: 'left'
  },
  grid: {
    width: '85%',
    marginLeft: theme.spacing(3)
  },
  textFields: {
    height: 31,
    fontSize: 12,
    width: '30ch'
  },
  textfieldInput: {
    height: 11,
    fontSize: '14px'
  },
  selectfieldInput: {
    height: 31,
    fontSize: 14,
    width: '26ch'
  },
  divider: {
    margin: '0px 24px 12px 24px'
  },

  buttonPadding: {
    padding: '3px 0'
  },

  checkboxfieldInput: {
    fontSize: '12px'
  }
});
export const customSelectStyles = {
  '.MuiOutlinedInput-notchedOutline': {
    border: 0
  },
  '&.MuiOutlinedInput-root fieldset': {
    border: 'white',
    padding: 0
  },
  '&.MuiSelect-select': {
    padding: 0
  },
  '&.Mui-focused fieldset': {
    border: 'white',
    color: 'black',
    padding: 0
  },
  '&.Mui-focused .MuiSelect-select': {
    padding: 0
  }
};
